import { TeammateRole } from '@/types/teammates';

export function getTeammateRoleDisplayName(role: TeammateRole): string {
  switch (role) {
    case TeammateRole.ADMIN:
      return 'Admin';
    case TeammateRole.ADVISOR:
      return 'Advisor';
    case TeammateRole.SUPPORTER:
      return 'Support';
    default:
      return '';
  }
}
